import { SearchFilterTag } from '@/components';
import type { ProjectSearchFormType } from '@/features/search/_models/projects-search';
import { ReviewTypeLabelModifier } from '@/utils/enum';
import type { FC } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const InspectionByExternalExpertReviewTypeTag: FC = () => {
  const { t } = useTranslation();

  const { control, setValue } = useFormContext<ProjectSearchFormType>();

  const sheetType = useWatch({
    control,
    name: 'sheetType',
  });
  const skipAdministrativeReformTeamEvaluation = useWatch({
    control,
    name: 'skipAdministrativeReformTeamEvaluation',
  });

  const inspectionByExternalExpertReviewType = useWatch({
    control,
    name: 'inspectionByExternalExpertReviewType',
  });

  if (
    sheetType !== 'RS' ||
    skipAdministrativeReformTeamEvaluation === 'true' ||
    !inspectionByExternalExpertReviewType?.length
  ) {
    return null;
  }

  const value = inspectionByExternalExpertReviewType
    .map((item) => ReviewTypeLabelModifier[item])
    .join(', ');

  return (
    <SearchFilterTag
      closable={true}
      label={`${t('inspection-target')}: ${value}`}
      onClose={() => {
        setValue('inspectionByExternalExpertReviewType', null);
      }}
    />
  );
};
